import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Link } from 'react-router-dom';

const NameTagList = ({ tags = [], linkForElement }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {tags.map(({ id, name }) => (
        <Chip key={id} variant="outlined" component={Link} label={name} to={linkForElement(id)} onClick={() => null} />
      ))}
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

export default NameTagList;
